import moment from 'moment';
import {Storage} from 'aws-amplify';
import {socialPostAllowedConstraints} from "../config/config";

export function removeGarbageChar(fileName) {
    const arr = fileName.split('.');
    const ext = arr.pop();
    const name = arr.join('.');
    const filterData = name.replace(/[^a-zA-Z0-9-_]/g, '');
    return `${filterData}.${ext}`;
}

export const uploadToS3 = async (file, folder, progressCallback = null) => {
    try {
        // Clean the file name
        const cleanedFileName = removeGarbageChar(file.name);

        // Generate a unique file path
        const filePath = `${folder ? `${folder}/` : ''}${Date.now()}_${cleanedFileName}`;
        // Prepare options with progress callback if provided
        const options = {
            contentType: file.type
        };

        // Add progressCallback if provided
        if (progressCallback) {
            options.progressCallback = (progress) => {
                const percentage = (progress.loaded / progress.total) * 100;
                progressCallback(percentage);
            };
        }

        // Upload the file to S3
        const result = await Storage.put(filePath, file, options);

        console.log('File uploaded successfully:', result.key);
        return result.key; // Return the file key
    } catch (error) {
        console.error('Error uploading file to S3:', error);
        throw error; // Rethrow the error for further handling
    }
}

export async function playAudio() {
    const audio = new Audio('https://www2.cs.uic.edu/~i101/SoundFiles/StarWars60.wav');
    // let file = new File('../assets/sounds/ding.mp3')
    // var audio = new Audio(ding);
    audio.type = 'audio/wav';

    try {
        await audio.play();
        console.log('Playing...');
    } catch (err) {
        console.log(err);
    }
}

export const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()\-_=+{}[\]|:;"'<>,./~`])[A-Za-z\d@$!%*?&#^()\-_=+{}[\]|:;"'<>,./~`]{8,}$/;

export function formatPhoneNumber(phoneNumber) {
    // Remove all spaces from the number
    let cleanedNumber = phoneNumber.replace(/\s+/g, '');

    if (cleanedNumber.slice(3, 5) === '00') {
        cleanedNumber = `${cleanedNumber.slice(0, 3)}0${cleanedNumber.slice(5)}`;
    }

    return cleanedNumber;
}

export function countActualCharacters(htmlText = '', platform = null, detailed = false) {
    if (!htmlText) return 0;

    const htmlString = convertToUnicodeStyledTextWithLinks(htmlText);
    console.log('htmlString', htmlString)
    const chars = [...htmlString];

    let totalCount = 0;
    const typeCounts = {
        bold: 0,
        italic: 0,
        emoji: 0,
        bullet: 0,
        normal: 0
    };

    // Process each character
    // eslint-disable-next-line no-restricted-syntax
    for (const char of chars) {
        const cp = char.codePointAt(0);

        // Initialize as normal text
        let type = "normal";
        let weight = 1;

        // BULLET CHARACTERS
        if (char === '•') {
            type = "bullet";
            weight = 3;
        }

        // EMOJI DETECTION - Common emoji blocks
        else if (
            (cp >= 0x1F300 && cp <= 0x1F5FF) || // Miscellaneous Symbols and Pictographs
            (cp >= 0x1F600 && cp <= 0x1F64F) || // Emoticons
            (cp >= 0x1F680 && cp <= 0x1F6FF) || // Transport and Map Symbols
            (cp >= 0x1F900 && cp <= 0x1F9FF)    // Supplemental Symbols and Pictographs
        ) {
            type = "emoji";
            weight = 2;
        }

        // BOLD DETECTION - Based on Unicode ranges
        else if (
            // Bold Fraktur range (includes mathematical bold characters)
            (cp >= 0x1D5D4 && cp <= 0x1D607) ||
            // Mathematical Bold ranges
            (cp >= 0x1D400 && cp <= 0x1D433) || // Mathematical Bold Capital
            (cp >= 0x1D468 && cp <= 0x1D49B) || // Mathematical Bold Small
            (cp >= 0x1D7CE && cp <= 0x1D7FF)    // Mathematical Bold Digits
        ) {
            type = "bold";
            weight = 2;
        }

        // ITALIC DETECTION - Based on Unicode ranges
        else if (
            // Mathematical Sans-Serif Italic range
            (cp >= 0x1D608 && cp <= 0x1D63B) ||
            // Mathematical Italic ranges
            (cp >= 0x1D434 && cp <= 0x1D467) || // Mathematical Italic Capital
            (cp >= 0x1D49C && cp <= 0x1D4CF)    // Mathematical Italic Small
        ) {
            type = "italic";
            weight = 2;
        }

        // Add to total count
        totalCount += weight;
        // eslint-disable-next-line no-plusplus
        typeCounts[type]++;
    }

    // Return just the total count if detailed info not requested
    if (!detailed) {
        return totalCount;
    }

    // Calculate weighted totals for each type
    const weightedCounts = {
        bold: typeCounts.bold * 2,
        italic: typeCounts.italic * 2,
        emoji: typeCounts.emoji * 2,
        bullet: typeCounts.bullet * 3,
        normal: typeCounts.normal,
        total: totalCount
    };

    return {
        totalCount,
        typeCounts,
        weightedCounts
    };
}

// Local timezone to UTC timezone
export const localToUtc = (date) => moment(date).utc().format('YYYY-MM-DDTHH:mm');

// UTC timezone to local time
export const utcToLocal = (date) => moment.utc(date).local().format('YYYY-MM-DDTHH:mm');

// convert date-time to YYYY-MM-DDTHH:mm format
export const formatDateTime = (date) => moment(date).format('YYYY-MM-DDTHH:mm');

// get the only date in YYYY-MM-DD format
export const getOnlyDate = (date) => moment(date).format('YYYY-MM-DD');

// get the only time in HH:mm format with AM/PM
export const getOnlyTime = (date) => moment(date).format('hh:mm A');

// calender post view date time format
export const CPVDateTimeFormat = (date) => moment(date).format('MMM DD, YYYY h:mm A');

// convert to unicode styled text with links
export const convertToUnicodeStyledTextWithLinks = (html) => {
    const boldMap = {
        'A': '𝗔', 'B': '𝗕', 'C': '𝗖', 'D': '𝗗', 'E': '𝗘', 'F': '𝗙', 'G': '𝗚', 'H': '𝗛', 'I': '𝗜', 'J': '𝗝',
        'K': '𝗞', 'L': '𝗟', 'M': '𝗠', 'N': '𝗡', 'O': '𝗢', 'P': '𝗣', 'Q': '𝗤', 'R': '𝗥', 'S': '𝗦', 'T': '𝗧',
        'U': '𝗨', 'V': '𝗩', 'W': '𝗪', 'X': '𝗫', 'Y': '𝗬', 'Z': '𝗭',
        'a': '𝗮', 'b': '𝗯', 'c': '𝗰', 'd': '𝗱', 'e': '𝗲', 'f': '𝗳', 'g': '𝗴', 'h': '𝗵', 'i': '𝗶', 'j': '𝗷',
        'k': '𝗸', 'l': '𝗹', 'm': '𝗺', 'n': '𝗻', 'o': '𝗼', 'p': '𝗽', 'q': '𝗾', 'r': '𝗿', 's': '𝘀', 't': '𝘁',
        'u': '𝘂', 'v': '𝘃', 'w': '𝘄', 'x': '𝘅', 'y': '𝘆', 'z': '𝘇',
        '0': '𝟬', '1': '𝟭', '2': '𝟮', '3': '𝟯', '4': '𝟰', '5': '𝟱', '6': '𝟲', '7': '𝟳', '8': '𝟴', '9': '𝟵',
        '!': '！',
        '?': '？',
        '.': '．',
        ',': '，',
        ':': '：',
        ';': '；',
        '-': '－',
        '+': '＋',
        '=': '＝',
        '(': '（',
        ')': '）',
        '[': '［',
        ']': '］',
        '{': '｛',
        '}': '｝',
        '<': '＜',
        '>': '＞',
        '/': '／',
        '\\': '＼',
        '&': '＆',
        '%': '％',
        '$': '＄',
        '#': '＃',
        '@': '＠',
        '^': '＾',
        '*': '＊',
        '_': '＿',
        '"': '＂',
        '\'': '＇',
        '`': '｀',
        '|': '｜',
    };

    const italicMap = {
        'A': '𝘈', 'B': '𝘉', 'C': '𝘊', 'D': '𝘋', 'E': '𝘌', 'F': '𝘍', 'G': '𝘎', 'H': '𝘏', 'I': '𝘐', 'J': '𝘑',
        'K': '𝘒', 'L': '𝘓', 'M': '𝘔', 'N': '𝘕', 'O': '𝘖', 'P': '𝘗', 'Q': '𝘘', 'R': '𝘙', 'S': '𝘚', 'T': '𝘛',
        'U': '𝘜', 'V': '𝘝', 'W': '𝘞', 'X': '𝘟', 'Y': '𝘠', 'Z': '𝘡',
        'a': '𝘢', 'b': '𝘣', 'c': '𝘤', 'd': '𝘥', 'e': '𝘦', 'f': '𝘧', 'g': '𝘨', 'h': '𝘩', 'i': '𝘪', 'j': '𝘫',
        'k': '𝘬', 'l': '𝘭', 'm': '𝘮', 'n': '𝘯', 'o': '𝘰', 'p': '𝘱', 'q': '𝘲', 'r': '𝘳', 's': '𝘴', 't': '𝘵',
        'u': '𝘶', 'v': '𝘷', 'w': '𝘸', 'x': '𝘹', 'y': '𝘺', 'z': '𝘻',
        '0': '𝟢', '1': '𝟣', '2': '𝟤', '3': '𝟥', '4': '𝟦', '5': '𝟧', '6': '𝟨', '7': '𝟩', '8': '𝟪', '9': '𝟫',
        '!': '！',
        '?': '？',
        '.': '．',
        ',': '，',
        ':': '：',
        ';': '；',
        '-': '－',
        '+': '＋',
        '=': '＝',
        '(': '（',
        ')': '）',
        '[': '［',
        ']': '］',
        '{': '｛',
        '}': '｝',
        '<': '＜',
        '>': '＞',
        '/': '／',
        '\\': '＼',
        '&': '＆',
        '%': '％',
        '$': '＄',
        '#': '＃',
        '@': '＠',
        '^': '＾',
        '*': '＊',
        '_': '＿',
        '"': '＂',
        '\'': '＇',
        '`': '｀',
        '|': '｜',
    };

    const htmlEntityMap = {
        '&rsquo;': '’',
        '&lsquo;': '‘',
        '&ldquo;': '“',
        '&rdquo;': '”',
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&nbsp;': ' ',
        '&quot;': '"',
        '&#39;': "'",
        '&#33;': '!',
        '&#43;': '+',
        '&#45;': '-',
        '&#47;': '/',
        '&#64;': '@',
        '&#35;': '#',
        '&#36;': '$',
        '&#37;': '%',
        '&#94;': '^',
        '&#42;': '*',
        '&#40;': '(',
        '&#41;': ')',
        '&Aacute;': 'Á',
        '&aacute;': 'á',
        '&Acirc;': 'Â',
        '&acirc;': 'â',
        '&Agrave;': 'À',
        '&agrave;': 'à',
        '&Aring;': 'Å',
        '&aring;': 'å',
        '&Atilde;': 'Ã',
        '&atilde;': 'ã',
        '&Auml;': 'Ä',
        '&auml;': 'ä',
        '&AElig;': 'Æ',
        '&aelig;': 'æ',
        '&Ccedil;': 'Ç',
        '&ccedil;': 'ç',
        '&Eacute;': 'É',
        '&eacute;': 'é',
        '&Ecirc;': 'Ê',
        '&ecirc;': 'ê',
        '&Egrave;': 'È',
        '&egrave;': 'è',
        '&Euml;': 'Ë',
        '&euml;': 'ë',
        '&Iacute;': 'Í',
        '&iacute;': 'í',
        '&Icirc;': 'Î',
        '&icirc;': 'î',
        '&Igrave;': 'Ì',
        '&igrave;': 'ì',
        '&Iuml;': 'Ï',
        '&iuml;': 'ï',
        '&Ntilde;': 'Ñ',
        '&ntilde;': 'ñ',
        '&Oacute;': 'Ó',
        '&oacute;': 'ó',
        '&Ocirc;': 'Ô',
        '&ocirc;': 'ô',
        '&Ograve;': 'Ò',
        '&ograve;': 'ò',
        '&Oslash;': 'Ø',
        '&oslash;': 'ø',
        '&Otilde;': 'Õ',
        '&otilde;': 'õ',
        '&Ouml;': 'Ö',
        '&ouml;': 'ö',
        '&szlig;': 'ß',
        '&Uacute;': 'Ú',
        '&uacute;': 'ú',
        '&Ucirc;': 'Û',
        '&ucirc;': 'û',
        '&Ugrave;': 'Ù',
        '&ugrave;': 'ù',
        '&Uuml;': 'Ü',
        '&uuml;': 'ü',
        '&Yacute;': 'Ý',
        '&yacute;': 'ý',
        '&thorn;': 'þ',
        '&THORN;': 'Þ',
        '&yuml;': 'ÿ',
        '&copy;': '©',
        '&reg;': '®',
        '&trade;': '™',
        '&euro;': '€',
        '&pound;': '£',
        '&yen;': '¥',
        '&sect;': '§',
        '&para;': '¶',
        '&bull;': '•',
        '&middot;': '·',
        '&hellip;': '…',
        '&laquo;': '«',
        '&raquo;': '»',
        '&lsaquo;': '‹',
        '&rsaquo;': '›',
        '&ndash;': '–',
        '&mdash;': '—',
        '&sbquo;': '‚',
        '&bdquo;': '„',
        '&dagger;': '†',
        '&Dagger;': '‡',
        '&permil;': '‰',
        '&frasl;': '⁄',
        '&#34;': '"',
        '&#38;': '&',
        '&#44;': ',',
        '&#58;': ':',
        '&#59;': ';',
        '&#61;': '=',
        '&#91;': '[',
        '&#92;': '\\',
        '&#93;': ']',
        '&#95;': '_',
        '&#96;': '`',
        '&#123;': '{',
        '&#124;': '|',
        '&#125;': '}',
        '&#126;': '~',
        '&#160;': '\u00A0',
        '&#161;': '¡',
        '&#162;': '¢',
        '&#163;': '£',
        '&#164;': '¤',
        '&#165;': '¥',
        '&#166;': '¦',
        '&#167;': '§',
        '&#168;': '¨',
        '&#169;': '©',
        '&#170;': 'ª',
        '&#171;': '«',
        '&#172;': '¬',
        '&#173;': '\u00AD',
        '&#174;': '®',
        '&#175;': '¯',
        '&#176;': '°',
        '&#177;': '±',
        '&#178;': '²',
        '&#179;': '³',
        '&#180;': '´',
        '&#181;': 'µ',
        '&#182;': '¶',
        '&#183;': '·',
        '&#184;': '¸',
        '&#185;': '¹',
        '&#186;': 'º',
        '&#187;': '»',
        '&#188;': '¼',
        '&#189;': '½',
        '&#190;': '¾',
        '&#191;': '¿',
        '&#215;': '×',
        '&#247;': '÷'
    };

    const decodeHtmlEntities = (text) => {
        return text.replace(/&[a-zA-Z0-9#]+;/g, (entity) => htmlEntityMap[entity] || entity);
    };

    const convertToBold = (text) => {
        if (!text) return '';
        return text.split('').map(char => boldMap[char] || char).join('');
    };

    const convertToItalic = (text) => {
        if (!text) return '';
        return text.split('').map(char => italicMap[char] || char).join('');
    };

    let processedHtml = decodeHtmlEntities(html);

    processedHtml = processedHtml
        .replace(/<strong>(.*?)<\/strong>/g, (match, text) => convertToBold(text)) // Bold
        .replace(/<em>(.*?)<\/em>/g, (match, text) => convertToItalic(text)) // Italic
        // .replace(/<a[^>]+href="([^"]+)"[^>]*>(.*?)<\/a>/g, (match, href, text) => {
        //     const styledText = convertToBold(text); // Make link text bold
        //     return `${styledText} ( ${href} )`; // Output with clickable format
        // })
        .replace(/<li[^>]*>(.*?)<\/li>/g, '• $1') // List items
        .replace(/<ul[^>]*>/g, '') // Unordered list open
        .replace(/<\/ul>/g, '') // Unordered list close
        .replace(/<p>&nbsp;<\/p>/g, '') // <p>&nbsp;</p> to newline
        .replace(/&nbsp;/g, ' ') // &nbsp; to space
        .replace(/<p[^>]*>/g, '') // Paragraph open
        .replace(/<\/p>/g, '') // Paragraph close
        .replace(/<[^>]+>/g, '') // Remove all other HTML tags
        .trim();

    return processedHtml;
};

export const mockValidateMedia = (files, platforms, isPublished, isPublishing) => {
    const errors = {};
    const mediaFiles = Array.isArray(files) ? files : [files];
    const imageFiles = mediaFiles.filter(file => file.type && file.type.startsWith('image'));
    const videoFiles = mediaFiles.filter(file => file.type && file.type.startsWith('video'));
    const hasMixedContent = imageFiles.length > 0 && videoFiles.length > 0;

    // Add update limitation errors for published posts. if you wanna allow force update, remove this check
    // if (isPublished || isPublishing) {
    //     if (platforms.includes(Platforms.twitter)) {
    //         if (!errors.twitter) errors.twitter = [];
    //         errors.twitter.push('Twitter does not allow updating content for published posts');
    //     }
    //
    //     if (platforms.includes(Platforms.linkedin) && (imageFiles.length > 0 || videoFiles.length > 0)) {
    //         if (!errors.linkedin) errors.linkedin = [];
    //         errors.linkedin.push('LinkedIn only allows text updates for published posts, not media changes');
    //     }
    // }

    // Original validation checks
    if (videoFiles.length > socialPostAllowedConstraints.maxVideoFileCount) {
        platforms.forEach(platform => {
            if (!errors[platform]) errors[platform] = [];
            errors[platform].push(`Too many videos. ${platform} allows maximum ${socialPostAllowedConstraints.maxVideoFileCount} video per post`);
        });
    }

    if (hasMixedContent) {
        const errorMessage = 'does not support mixing images and videos in the same post';

        // Check each platform and add the error if platform is selected
        PlatformsArr.forEach(platform => {
            if (platforms.includes(Platforms[platform])) {
                errors[platform] = errors[platform] || [];
                errors[platform].push(`${platform.charAt(0).toUpperCase() + platform.slice(1)} ${errorMessage}`);
            }
        });
    }

    if (imageFiles.length > 0) {
        if (platforms.includes(Platforms.facebook) && imageFiles.length > socialPostAllowedConstraints.fbMaxImageFileCount) {
            if (!errors.facebook) errors.facebook = [];
            errors.facebook.push(`Too many images. Facebook allows maximum ${socialPostAllowedConstraints.fbMaxImageFileCount} images per post`);
        }
        if (platforms.includes(Platforms.linkedin) && imageFiles.length > socialPostAllowedConstraints.inMaxImageFileCount) {
            if (!errors.linkedin) errors.linkedin = [];
            errors.linkedin.push(`Too many images. LinkedIn allows maximum ${socialPostAllowedConstraints.inMaxImageFileCount} images per post`);
        }
        if (platforms.includes(Platforms.twitter) && imageFiles.length > socialPostAllowedConstraints.twMaxImageFileCount) {
            if (!errors.twitter) errors.twitter = [];
            errors.twitter.push(`Too many images. Twitter allows maximum ${socialPostAllowedConstraints.twMaxImageFileCount} images per post`);
        }
    }

    mediaFiles.forEach(file => {
        const isVideo = file.type && file.type.startsWith('video');
        if (platforms.includes(Platforms.facebook)) {
            if (isVideo && file.size > socialPostAllowedConstraints.fbMaxVideoFileSizeInTotal * 1024 * 1024) {
                if (!errors.facebook) errors.facebook = [];
                errors.facebook.push(`Video size exceeds Facebook maximum (${socialPostAllowedConstraints.fbMaxVideoFileSizeInTotal}MB)`);
            } else if (!isVideo && file.size > socialPostAllowedConstraints.fbMaxImageFileSizeInTotal * 1024 * 1024) {
                if (!errors.facebook) errors.facebook = [];
                errors.facebook.push(`Image size exceeds Facebook maximum (${socialPostAllowedConstraints.fbMaxImageFileSizeInTotal}MB)`);
            }
        }
        if (platforms.includes(Platforms.linkedin)) {
            if (isVideo && file.size > socialPostAllowedConstraints.inMaxVideoFileSizeInTotal * 1024 * 1024) {
                if (!errors.linkedin) errors.linkedin = [];
                errors.linkedin.push(`Video size exceeds LinkedIn maximum (${socialPostAllowedConstraints.inMaxVideoFileSizeInTotal}MB)`);
            } else if (!isVideo && file.size > socialPostAllowedConstraints.inMaxImageFileSizeInTotal * 1024 * 1024) {
                if (!errors.linkedin) errors.linkedin = [];
                errors.linkedin.push(`Image size exceeds LinkedIn maximum (${socialPostAllowedConstraints.inMaxImageFileSizeInTotal}MB)`);
            }
        }
        if (platforms.includes(Platforms.twitter)) {
            if (isVideo && file.size > socialPostAllowedConstraints.twMaxVideoFileSizeInTotal * 1024 * 1024) {
                if (!errors.twitter) errors.twitter = [];
                errors.twitter.push(`Video size exceeds Twitter maximum (${socialPostAllowedConstraints.twMaxVideoFileSizeInTotal}MB)`);
            } else if (!isVideo && file.size > socialPostAllowedConstraints.twMaxImageFileSizeInTotal * 1024 * 1024) {
                if (!errors.twitter) errors.twitter = [];
                errors.twitter.push(`Image size exceeds Twitter maximum (${socialPostAllowedConstraints.twMaxImageFileSizeInTotal}MB)`);
            }
            console.log('duration', file)
            if (isVideo && file.duration > socialPostAllowedConstraints.twMaxVideoFileDuration) {
                if (!errors.twitter) errors.twitter = [];
                errors.twitter.push(`Video duration exceeds Twitter maximum (${socialPostAllowedConstraints.twMaxVideoFileDuration} seconds)`);
            }
        }
    });

    return errors;
};

export const calculateTotalSize = (selectedFiles) => {
    let totalSize = 0;

    selectedFiles.forEach((file) => {
        // Check all possible size properties in order of preference
        if (file instanceof File || file instanceof Blob) {
            totalSize += Number(file.size);
        } else if (file.originalSize !== undefined) {
            // Handle files with originalSize property (our enhanced files)
            totalSize += Number(file.originalSize);
        } else if (file.size !== undefined) {
            // Handle objects with direct size property
            totalSize += Number(file.size);
        } else {
            console.warn('Unable to calculate size for file:', file);
            // Don't add anything to the total
        }
    });

    // Check if totalSize is actually a number before converting
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(totalSize) || totalSize === 0) {
        console.warn('Total size calculation resulted in an invalid value:', totalSize);
        return '0.00';
    }

    // Convert to MB with 2 decimal places
    return (totalSize / (1024 * 1024)).toFixed(2);
};

export const getFileType = (fileType) => {
    if (fileType.startsWith('image')) {
        return 'image';
    }
    if (fileType.startsWith('video')) {
        return 'video';
    }
    return 'unknown';
};

export const Platforms = {
    facebook: 'facebook',
    linkedin: 'linkedin',
    twitter: 'twitter'
}

export const PlatformsObj = {
    facebook: {
        name: Platforms.facebook,
        icon: 'cib:facebook',
        color: '#3B5998',
    },
    linkedin: {
        name: Platforms.linkedin,
        icon: 'entypo-social:linkedin-with-circle',
        color: '#0077B5',
    },
    twitter: {
        name: Platforms.twitter,
        icon: 'hugeicons:new-twitter-ellipse',
        color: '#000000',
    }
}

export const PlatformsArr = [Platforms.facebook, Platforms.linkedin, Platforms.twitter]

export const PLATFORM_IDS = {
    facebook: 1,
    linkedin: 2,
    twitter: 3,
};

export const isPostedToPlatform = (nameToCheck, platformArray) => {
    const normalizedNameToCheck = nameToCheck.toLowerCase();

    // Check if any platform in the array has a matching name
    return platformArray.some(platform =>
        platform.name.toLowerCase() === normalizedNameToCheck
    );
};

export const getMostRestrictivePlatform = (platforms) => {
    const platformLimits = platforms.map(platform => {
        switch (platform.toLowerCase()) {
            case Platforms.facebook:
                return {
                    name: PlatformsObj[platform].name,
                    icon: PlatformsObj[platform].icon,
                    color: PlatformsObj[platform].color,
                    limit: socialPostAllowedConstraints.fbMaxCharacterCount
                };
            case Platforms.linkedin:
                return {
                    name: PlatformsObj[platform].name,
                    icon: PlatformsObj[platform].icon,
                    color: PlatformsObj[platform].color,
                    limit: socialPostAllowedConstraints.inMaxCharacterCount
                };
            case Platforms.twitter:
                return {
                    name: PlatformsObj[platform].name,
                    icon: PlatformsObj[platform].icon,
                    color: PlatformsObj[platform].color,
                    limit: socialPostAllowedConstraints.twMaxCharacterCount
                };
            default:
                return null;
        }
    }).filter(Boolean);

    // Find the most restrictive platform (lowest char limit)
    return platformLimits.length > 0
        ? platformLimits.reduce((prev, current) => (prev.limit < current.limit) ? prev : current)
        : {name: 'Platforms', icon: 'mdi:web', color: '#666666', limit: 3000}; // Default if no platforms selected
}
